<template>
<div class="teacherStatistics">
  <div class="module">
    <div class="item">
      <div class="title">教职工人数统计</div>
      <div class="content">
        <div class="teacherNumber">
          <div v-for="item in teacherData">
            <p class="num">{{item.rs}}人</p>
            <p class="text">{{item.ryfl}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="title">教职工男女比例</div>
      <div class="content" id="maleFemaleRatio">
      </div>
    </div>
  </div>
  <div class="module">
    <div class="item">
      <div class="title">各单位教职工情况</div>
      <div class="content" id="deptTeacher">

      </div>
    </div>
    <div class="item">
      <div class="title">本学期各单位教职工授课情况</div>
      <div class="content" id="deptTeacherGive">

      </div>
    </div>
  </div>
  <div class="module">
    <div class="item">
      <div class="title">当日各单位请假人数统计</div>
      <div class="content" id="deptLeave">

      </div>
    </div>
    <div class="item">
      <div class="title">授课TOP10教职工</div>
      <el-switch
      style="display: block;position: absolute;right: 25px;top: 25px"
      v-model="rankingType"
      active-text="课时"
      inactive-text="课程">
      </el-switch>
      <div class="content">
        <div class="rankingList">
          <div class="row">
            <div>排名</div>
            <div>姓名</div>
            <div>{{rankingType ? '课时':'课程'}}</div>
          </div>
          <template v-if="rankingType">
            <div class="row" v-for="item in timeTopData">
              <div>{{item.pm}}</div>
              <div>{{item.jzgxm}}</div>
              <div>{{item.skks}}</div>
            </div>
          </template>
          <template v-if="!rankingType">
            <div class="row" v-for="item in numberTopData">
              <div>{{item.pm}}</div>
              <div>{{item.jzgxm}}</div>
              <div>{{item.skkcs}}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import axios from "axios";
  import apiConfig from "../../common/js/api_config";

  export default {
    name: "teacherStatistics",
    data() {
      return {
        staffColor: ['#1F89DF', '#49A3EC', '#6FB7F2', '#91C7AE', '#A2A860', '#91C7AE', '#EEC714', '#EEB814', '#6ABD9D'],
        teacherData: [],
        rankingType: false,
        timeTopData: [],
        numberTopData: []
      }
    },
    methods: {
      // 教职工数量
      async getTeacherNumber() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jzg_jzgtj')
        this.teacherData = resp.data.data
      },
      // 教职工男女比例
      async getMaleFemaleRatioData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jzg_jzgxbtj')
        let data = resp.data.data
        data.map(item => {
          item.name = item.xb
          item.value = item.rs
        })
        this.drawMaleFemaleRatio(data)
      },
      drawMaleFemaleRatio (data) {
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            formatter: '{b} <br/>{a}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 60,
            top: 42,
            itemWidth: 10,
            itemHeight: 10,
            data: data.map(item => item.name)
          },
          series: [
            {
              name: '人数',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['45%', '65%'],
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              color: this.staffColor,
              data: data
            }
          ]
        };
        this.maleFemaleRatioBox.setOption(option)
      },
      // 各单位教职工情况
      async getDeptTeacherData () {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jzg_jzgdwtj')
        let dwArray = []
        let rsArray = []
        resp.data.data.map(item => {
          dwArray.push(item.dwmc)
          rsArray.push(item.rs)
        })
        this.drawDeptTeacher(dwArray,rsArray)
      },
      drawDeptTeacher(dwArray, rsArray) {
        let option = {
          color: ['#1F89DF'],
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: dwArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],

          dataZoom: [
            {
              show: true,
              start: 0,
              end: 20
            },
            {
              type: 'inside',
              start: 0,
              end: 20
            },

          ],
          series: [
            {
              name: '人数',
              type: 'bar',
              barWidth: '60%',
              data: rsArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0]
              },
              barMaxWidth: 20
            }
          ]
        };
        this.deptTeacherBox.setOption(option)
      },
      // 本学期各单位教职工授课情况
      async getDeptTeacherGiveData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jzg_bxqgdwjzgskqk')
        let dwArray = []
        let rsArray = []
        let zrsArray = []
        resp.data.data.map(item => {
          dwArray.push(item.dwmc)
          rsArray.push(item.skrs)
          zrsArray.push(item.zrs)
        })
        this.drawDeptTeacherGive(dwArray, rsArray,zrsArray)
      },
      drawDeptTeacherGive(dwArray, rsArray,zrsArray) {
        let option = {
          color: ['#1F89DF'],
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: dwArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],

          dataZoom: [
            {
              show: true,
              start: 0,
              end: 20
            },
            {
              type: 'inside',
              start: 0,
              end: 20
            },

          ],
          series: [
            {
              name: '总人数',
              type: 'bar',
              barWidth: '60%',
              data: zrsArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
              barGap: '-100%',
              z: '0'
            },
            {
              name: '授课人数',
              type: 'bar',
              barWidth: '60%',
              data: rsArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
                color: 'rgb(38, 223, 254)'
              },
              barMaxWidth: 20
            }
          ]
        };
        this.deptTeacherGiveBox.setOption(option)
      },
      // 当日各单位请假人数统计
      async getDeptLeaveData () {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jzg_jyzgdwqjrstj')
        let dwArray = []
        let rsArray = []
        let zrsArray = []
        resp.data.data.map(item => {
          dwArray.push(item.dwmc)
          rsArray.push(item.qjrs)
          zrsArray.push(item.zrs)
        })
        this.drawDeptLeave(dwArray, rsArray,zrsArray)

      },
      drawDeptLeave (dwArray, rsArray,zrsArray) {
        let option = {
          color: ['#1F89DF'],
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: dwArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],

          dataZoom: [
            {
              show: true,
              start: 0,
              end: 20
            },
            {
              type: 'inside',
              start: 0,
              end: 20
            },

          ],
          series: [
            {
              name: '总人数',
              type: 'bar',
              barWidth: '60%',
              data: zrsArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
              barGap: '-100%',
              z: '0'
            },
            {
              name: '请假人数',
              type: 'bar',
              barWidth: '60%',
              data: rsArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
                color: 'rgb(38, 223, 254)'
              },
              barMaxWidth: 20
            }
          ]
        };
        this.deptLeaveBox.setOption(option)
      },
      // top
      async getTimeTopData () {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jzg_skkstop10jzgxm')
        this.timeTopData = resp.data.data.slice(0, 10)
      },
      async getNumberTopData () {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jzg_skkcstop10jzgxm')
        this.numberTopData = resp.data.data.slice(0, 10)
      }
    },
    mounted() {
      this.maleFemaleRatioBox = this.$echarts.init(document.getElementById('maleFemaleRatio'))
      this.deptTeacherBox = this.$echarts.init(document.getElementById('deptTeacher'))
      this.deptTeacherGiveBox = this.$echarts.init(document.getElementById('deptTeacherGive'))
      this.deptLeaveBox = this.$echarts.init(document.getElementById('deptLeave'))
      this.getTeacherNumber()
      this.getMaleFemaleRatioData()
      this.getDeptTeacherData()
      this.getDeptTeacherGiveData()
      this.getDeptLeaveData()

      this.getTimeTopData()
      this.getNumberTopData()
      window.addEventListener('resize', () => {
        this.maleFemaleRatioBox.resize()
        this.deptTeacherBox.resize()
        this.deptTeacherGiveBox.resize()
        this.deptLeaveBox.resize()
      })
    }
  }
</script>

<style lang="stylus" scoped>
.teacherStatistics
  width 100%
  color #333
  .module
    width 100%
    height 350px
    margin-top 25px
    display flex
    justify-content space-between
    .item
      width 49.5%
      height 100%
      background #fff
      border-radius 10px
      overflow hidden
      position relative

      .title
        width 100%
        height 20%
        display flex
        align-items center
        justify-content center
        font-size 18px
        font-weight bold
      .content
        width 100%
        height 80%
        .teacherNumber
          width 100%
          height 100%
          display flex
          align-items center
          justify-content space-around
          div
            display flex
            flex-direction column
            justify-content center
            align-items center
            .num
              font-size 26px
            .text
              font-size 18px
              margin-top 25px
        .rankingList
          width 100%
          height 100%
          overflow-y scroll
          margin 0 auto
          &::-webkit-scrollbar
            display none
          .row
            width 100%
            height 40px
            display flex
            align-items center
            justify-content space-between
            div
              width 33%
              height 100%
              display flex
              align-items center
              justify-content center
</style>


// WEBPACK FOOTER //
// src/components/datanalysis/teacherStatistics.vue